import React from "react"
import Collapsible from "react-collapsible"
import { accordionUniqueId } from "@/utils/index"

const productAccordion = props => {
  const {
    title = "",
    analyticTitleData = null,
    analyticTitleCustomData = null,
    showOnPrint = false,
    handleOpen = () => {},
    handleClose = () => {},
    isOpen = false,
    children = undefined,
  } = props
  const CollapsibleHeader = () => (
    <div
      className="collapsible__header gbh-data-layer"
      data-gbh-data-layer={analyticTitleData}
      data-gbh-data-layer-custom={analyticTitleCustomData}
    >
      <span role="heading" aria-level="2">
        {title}
      </span>
      <div className="plus">
        <div className="line line-1"></div>
        <div className="line line-2"></div>
      </div>
    </div>
  )

  return (
    <div
      className={`pdp-support-files container-fluid ${
        !showOnPrint ? "no-print" : ""
      }`}
    >
      <div
        className="pdp-support-files__content collapsible-accordion"
        data-testid={`product-accordion-${title}`}
      >
        <Collapsible
          trigger={<CollapsibleHeader />}
          onTriggerOpening={handleOpen}
          onTriggerClosing={handleClose}
          triggerOpenedClassName="collapsible__trigger--open"
          open={isOpen}
          openedClassName="collapsible--open"
          transitionTime={400}
          tabIndex="0"
          easing="ease-in-out"
          triggerElementProps={{
            id: accordionUniqueId("collapsible-trigger", 9999, 1000),
          }}
          contentElementId={accordionUniqueId(
            "collapsible-content",
            9999,
            1000
          )}
        >
          <div
            className="row no-gutters px-0"
            data-testid={`colapse-data-${title}`}
            aria-disabled={isOpen}
          >
            <div className="pdp-support-files__download-section col-12">
              {children}
            </div>
          </div>
        </Collapsible>
      </div>
    </div>
  )
}

export default productAccordion
